module.exports = __webpack_public_path__ + "static/media/sheridan-news.4caec70e.jpg";